import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted, inject } from 'vue'
import TripReviewItinerary from '@/components/TripReviewItinerary.vue'
import TripReviewRequirements from '@/components/TripReviewRequirements.vue'
import TripReviewMetadata from '@/components/TripReviewMetadata.vue'
import tripModificationStore from '@/store/modules/tripModification'
import TripModificationPayment from './TripModificationPayment.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'TripModificationReview',
  setup(__props) {

const removePadding = inject('removePadding', false)

const currentTrip = computed(() => tripModificationStore.currentTrip)
const requestedTripForReview = computed(() => tripModificationStore.requestedTripForReview)
const paymentUpdate = computed(() => tripModificationStore.paymentUpdate)

const changesMade = computed(() => {
  const req = requestedTripForReview.value
  if (!req) return false
  const requirementsModified =
    req.adaChanged ||
    req.spabChanged ||
    req.vehicleNeededEntireTripChanged
  const metadataModified =
    req.passengerCountChanged ||
    req.tripTypeChanged ||
    req.vehiclesChanged
  const stopsModified = req.stops?.some((stop: any) => stop.stopChanged)
  return requirementsModified || metadataModified || stopsModified
})

const isMobile = computed(() => {
  return (window as any).$vuetify?.breakpoint?.xsOnly
})

const isDraftCustomerReview = computed(() => tripModificationStore.isDraftCustomerReview)

onMounted(async () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })

  tripModificationStore.setForwardButtonDisabled(false)
})

return { __sfc: true,removePadding, currentTrip, requestedTripForReview, paymentUpdate, changesMade, isMobile, isDraftCustomerReview, TripReviewItinerary, TripReviewRequirements, TripReviewMetadata, TripModificationPayment }
}

})